var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.957,
    height: 41.957,
    viewBox: "0 0 41.957 41.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33561",
    "data-name": "Group 33561",
    transform: "translate(-1577 -98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13737",
    "data-name": "Rectangle 13737",
    width: 41.957,
    height: 41.957,
    rx: 8,
    transform: "translate(1577 98)",
    fill: "#ffebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "alert",
    transform: "translate(1589 110)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61409",
    "data-name": "Path 61409",
    d: "M9,1a8,8,0,1,0,8,8A8,8,0,0,0,9,1ZM9,15.545A6.545,6.545,0,1,1,15.545,9,6.545,6.545,0,0,1,9,15.545Z",
    fill: "#fc4747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61410",
    "data-name": "Path 61410",
    d: "M11.727,6A.727.727,0,0,0,11,6.727v5.091a.727.727,0,0,0,1.455,0V6.727A.727.727,0,0,0,11.727,6Z",
    transform: "translate(-2.727 -1.364)",
    fill: "#fc4747"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1649",
    "data-name": "Ellipse 1649",
    cx: 0.727,
    cy: 0.727,
    r: 0.727,
    transform: "translate(8.273 11.909)",
    fill: "#fc4747"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDanger);
export default __webpack_public_path__ + "static/media/IconDanger.e4e7e612.svg";
export { ForwardRef as ReactComponent };